import { requiredMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

export const genericSelectValidator = trimmedString;
export const genericSelectValidatorRequired =
  trimmedString.required(requiredMessage);
